<template>
  <div class="banner-slider-wrapper">
    <!-- Skeleton loading - only shown during initial load -->
    <div v-if="loading && isInitialLoad" class="banner-slider skeleton-banner">
      <div class="skeleton-slide">
        <div class="skeleton-pulse"></div>
      </div>
    </div>

    <!-- Loading overlay for subsequent loads -->
<!--    <div v-else-if="loading && !isInitialLoad" class="banner-slider position-relative">-->
<!--      <div class="loading-overlay">-->
<!--        <div class="overlay-backdrop"></div>-->
<!--        <div class="spinner-container d-flex align-items-center">-->
<!--          <svg class="spinner-icon me-3" viewBox="0 0 50 50">-->
<!--            <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5"/>-->
<!--          </svg>-->
<!--        </div>-->
<!--      </div>-->

<!--      &lt;!&ndash; Show existing content with overlay &ndash;&gt;-->
<!--      <div class="opacity-50">-->
<!--        <div-->
<!--          class="slider-container"-->
<!--          :class="{ 'dragging': dragging }"-->
<!--          ref="sliderContainer"-->
<!--        >-->
<!--          <div-->
<!--            class="slider-track"-->
<!--            :style="{-->
<!--              transform: `translateX(calc(${-currentIndex * 100}% - ${currentIndex * 50}px + ${dragging ? dragOffset : 0}px))`,-->
<!--              transition: dragging ? 'none' : 'transform 0.3s ease-out'-->
<!--            }"-->
<!--          >-->
<!--            <div v-for="(slide, index) in slides" :key="slide.id" class="slider-slide">-->
<!--              <div class="slide-content">-->
<!--                <picture class="slide-image">-->
<!--                  <img loading="lazy" class="w-100" src="/images/hero-filter.jpg" alt="">-->
<!--                </picture>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->

    <!-- Actual content when not loading -->
    <div v-else class="banner-slider">
      <div
        class="slider-container"
        :class="{ 'dragging': dragging }"
        ref="sliderContainer"
        @mousedown="startDrag"
        @mousemove="onDrag"
        @mouseup="endDrag"
        @mouseleave="endDrag"
        @touchstart="startDrag"
        @touchmove="onDrag"
        @touchend="endDrag"
      >
        <div
          class="slider-track"
          :style="{
            transform: `translateX(calc(${-currentIndex * 100}% - ${currentIndex * 50}px + ${dragging ? dragOffset : 0}px))`,
            transition: dragging ? 'none' : 'transform 0.3s ease-out'
          }"
        >
          <div v-for="(slide, index) in slides" :key="slide.id" class="slider-slide">
            <a
              v-if="slide.url"
              :href="slide.url"
              @click="(e) => { if (isDragged) e.preventDefault(); }"
            >
              <div class="slide-content">
                <picture class="slide-image">
                  <source v-if="getSlideImage(slide, 'PURPOSE_BANNER_XLARGE_IMAGE')" media="(min-width: 1200px)" :srcset="getSlideImage(slide, 'PURPOSE_BANNER_XLARGE_IMAGE')">
                  <source v-if="getSlideImage(slide, 'PURPOSE_BANNER_LARGE_IMAGE')" media="(min-width: 992px)" :srcset="getSlideImage(slide, 'PURPOSE_BANNER_LARGE_IMAGE')">
                  <source v-if="getSlideImage(slide, 'PURPOSE_BANNER_MEDIUM_IMAGE')" media="(min-width: 576px)" :srcset="getSlideImage(slide, 'PURPOSE_BANNER_MEDIUM_IMAGE')">
                  <source v-if="getSlideImage(slide, 'PURPOSE_BANNER_SMALL_IMAGE')" media="(max-width: 575px)" :srcset="getSlideImage(slide, 'PURPOSE_BANNER_SMALL_IMAGE')">
                  <img loading="lazy" class="w-100" :src="getSlideImage(slide, 'PURPOSE_BANNER_XLARGE_IMAGE') || '/images/hero-filter.jpg'" alt="">
                </picture>
              </div>
            </a>
            <div v-else class="slide-content">
              <picture class="slide-image">
                <source v-if="getSlideImage(slide, 'PURPOSE_BANNER_XLARGE_IMAGE')" media="(min-width: 1200px)" :srcset="getSlideImage(slide, 'PURPOSE_BANNER_XLARGE_IMAGE')">
                <source v-if="getSlideImage(slide, 'PURPOSE_BANNER_LARGE_IMAGE')" media="(min-width: 992px)" :srcset="getSlideImage(slide, 'PURPOSE_BANNER_LARGE_IMAGE')">
                <source v-if="getSlideImage(slide, 'PURPOSE_BANNER_MEDIUM_IMAGE')" media="(min-width: 576px)" :srcset="getSlideImage(slide, 'PURPOSE_BANNER_MEDIUM_IMAGE')">
                <source v-if="getSlideImage(slide, 'PURPOSE_BANNER_SMALL_IMAGE')" media="(max-width: 575px)" :srcset="getSlideImage(slide, 'PURPOSE_BANNER_SMALL_IMAGE')">
                <img loading="lazy" class="w-100" :src="getSlideImage(slide, 'PURPOSE_BANNER_XLARGE_IMAGE') || '/images/hero-filter.jpg'" alt="">
              </picture>
            </div>
          </div>
        </div>
      </div>

      <!-- Navigation arrows -->
      <button
        v-if="slides.length > 1"
        class="slider-arrow slider-arrow-prev"
        @click="prevSlide"
        aria-label="Previous slide"
      >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
          <path fill="currentColor" d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"/>
        </svg>
      </button>
      <button
        v-if="slides.length > 1"
        class="slider-arrow slider-arrow-next"
        @click="nextSlide"
        aria-label="Next slide"
      >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
          <path fill="currentColor" d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"/>
        </svg>
      </button>
    </div>

    <!-- Navigation dots - moved below the banner-slider container -->
    <div class="slider-dots-container" v-if="!loading && slides.length > 0">
      <div class="slider-dots">
        <button
          v-for="(slide, index) in slides"
          :key="`dot-${index}`"
          class="slider-dot"
          :class="{ active: currentIndex === index }"
          @click="goToSlide(index)"
          aria-label="Go to slide"
        ></button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted, watch } from 'vue';

const props = defineProps({
  slides: {
    type: Array,
    required: true
  },
  autoplayInterval: {
    type: Number,
    default: 10000 // 10 seconds
  },
  getSlideImage: {
    type: Function,
    required: true
  },
  loading: {
    type: Boolean,
    default: false
  },
  isInitialLoad: {
    type: Boolean,
    default: false
  }
});

const currentIndex = ref(0);
const dragging = ref(false);
const startX = ref(0);
const currentX = ref(0);
const dragOffset = ref(0);
const isDragged = ref(false);
const sliderContainer = ref(null);
let autoplayTimer = null;

// Start autoplay
const startAutoplay = () => {
  stopAutoplay();
  if (props.slides.length > 1) {
    autoplayTimer = setInterval(() => {
      nextSlide();
    }, props.autoplayInterval);
  }
};

// Stop autoplay
const stopAutoplay = () => {
  if (autoplayTimer) {
    clearInterval(autoplayTimer);
    autoplayTimer = null;
  }
};

// Go to specific slide
const goToSlide = (index) => {
  currentIndex.value = index;
  startAutoplay(); // Reset autoplay timer
};

// Go to next slide
const nextSlide = () => {
  currentIndex.value = (currentIndex.value + 1) % props.slides.length;
};

// Go to previous slide
const prevSlide = () => {
  currentIndex.value = (currentIndex.value - 1 + props.slides.length) % props.slides.length;
};

// Start drag
const startDrag = (e) => {
  // For mouse events, only start drag on left button (button 0)
  if (e.type === 'mousedown' && e.button !== 0) {
    return;
  }

  dragging.value = true;
  isDragged.value = false;
  startX.value = e.type === 'touchstart' ? e.touches[0].clientX : e.clientX;
  currentX.value = startX.value;
  stopAutoplay();

  // Prevent default for mouse events to avoid text selection
  if (e.type === 'mousedown') {
    e.preventDefault();
  }
};

// During drag
const onDrag = (e) => {
  if (!dragging.value) return;

  // Always prevent default for mouse events to enable desktop swiping
  if (e.type === 'mousemove') {
    e.preventDefault();
  }

  const clientX = e.type === 'touchmove' ? e.touches[0].clientX : e.clientX;
  const deltaX = clientX - startX.value;
  currentX.value = clientX;

  // Calculate drag offset in pixels
  dragOffset.value = deltaX;

  // Mark as dragged if moved more than 5px
  if (Math.abs(deltaX) > 5) {
    isDragged.value = true;
  }

  // For touch events, only prevent default if we're sure it's a horizontal swipe
  if (e.type === 'touchmove' && Math.abs(deltaX) > 5) {
    e.preventDefault();
  }
};

// End drag
const endDrag = (e) => {
  if (!dragging.value) return;

  const deltaX = currentX.value - startX.value;
  const threshold = sliderContainer.value ? sliderContainer.value.offsetWidth * 0.2 : 50;

  if (deltaX < -threshold) {
    nextSlide();
  } else if (deltaX > threshold) {
    prevSlide();
  }

  // Reset drag state
  dragging.value = false;
  dragOffset.value = 0;

  // Keep isDragged flag for a short time to prevent link clicks
  setTimeout(() => {
    isDragged.value = false;
  }, 50);

  startAutoplay();
};

// Watch for changes in slides
watch(() => props.slides, () => {
  currentIndex.value = 0;
  startAutoplay();
}, { deep: true });

onMounted(() => {
  startAutoplay();
});

onUnmounted(() => {
  stopAutoplay();
});
</script>

<style scoped>
.banner-slider-wrapper {
  position: relative;
  width: 100%;
  margin: 0;
  padding: 0;
  overflow: hidden;
}

.banner-slider {
  position: relative;
  width: 100%;
  overflow: hidden;
  border-radius: 0.3rem;
  margin: 0;
  padding-bottom: 0;
}

/* Skeleton styles are now in the parent component (CarFilter.vue) */

/* Rounder corners for desktop */
@media (min-width: 992px) {
  .banner-slider {
    border-radius: 0.8rem;
  }
}

.slider-container {
  width: 100%;
  overflow: hidden;
  touch-action: pan-y;
  cursor: grab;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  margin: 0;
  padding: 0;
}

.slider-container.dragging {
  cursor: grabbing;
}

.slider-track {
  display: flex;
  width: 100%;
  /* Allow for smooth transition between slides */
  will-change: transform;
  margin: 0;
  padding: 0;
}

.slider-slide {
  flex: 0 0 100%;
  width: 100%;
  max-height: 272px;
  box-sizing: border-box;
  /* Add right margin for gap between slides, only visible during swiping */
  margin: 0 50px 0 0;
  padding: 0;
}

@media (max-width: 575px) {
    .slider-slide {
        max-height: 180px;
    }
}

/* Remove margin from the last slide */
.slider-slide:last-child {
  margin-right: 0;
}

.slide-content {
  width: 100%;
  height: 100%;
  position: relative;
  margin: 0;
  padding: 0;
}

.slide-image {
  width: 100%;
  height: 100%;
  display: block;
  margin: 0;
  padding: 0;
  border-radius: 0.3rem;
  overflow: hidden;
  position: relative;
}

/* Rounder corners for desktop */
@media (min-width: 992px) {
  .slide-image {
    border-radius: 0.8rem;
  }
}

.slide-image img {
  width: 100%;
  height: 272px;
  object-fit: cover;
  object-position: center;
  display: block;
  margin: 0;
  padding: 0;
}

@media (max-width: 575px) {
    .slide-image img {
        max-height: 180px;
    }
}

/* Navigation arrows */
.slider-arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 40px;
  height: 40px;
  background-color: rgba(255, 255, 255, 0.7);
  border: none;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 10;
  transition: all 0.3s ease;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
}

.slider-arrow:hover {
  background-color: rgba(255, 255, 255, 0.9);
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.3);
}

.slider-arrow-prev {
  left: 15px;
}

.slider-arrow-next {
  right: 15px;
}

.slider-arrow svg {
  color: #333;
}

/* Navigation dots container */
.slider-dots-container {
  width: 100%;
  margin-top: 5px;
  text-align: center;
}

/* Navigation dots */
.slider-dots {
  display: inline-flex;
  justify-content: center;
  margin: 0 auto;
}

.slider-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #aaa;
  border: none;
  margin: 0 5px;
  padding: 0;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.slider-dot.active {
  background-color: #1EF1C6; /* Blue for active dot */
}
</style>
